let $ = require("jquery");
import _, { delay } from "underscore";
import render from '../../utilities/render';
import {isFalsey, isBlank} from '../../utilities/general'
import {setElementsFromScope} from '../../utilities/selectorHelpers';
const fxoCasAccountTemplate = require("./html/fxoCasAccountTemplate.html");

const elementsPageMap = {
  casAccountEditContainer: ".fxo-cas-account-edit-container",
  noCasAccountEditContainer: ".fxo-no-cas-account-edit-container",
  noCasAccountEditContainers: ".fxo-no-cas-account-edit-containers",
  packagingSkusEditContainer: ".fxo-packaging-skus-edit-container",
  accumulationShipSchedEditContainer: ".fxo-acc-ship-sched-edit-container",

  fxoConfigCasAddButton: ".fxo-config-cas-add-button",
  fxoConfigCasEditButton: ".fxo-config-cas-edit-button",
  fxoConfigCasEditText: ".fxo-config-cas-edit-text",
  casAccountNo: ".cas-account-no",
  casAccountType: ".cas-account-type",
  casServiceSku: ".cas-service-sku",
  casAccountNumberInput: ".cas-account-number-input",
  casAccountTypeInput: ".cas-account-type-input",
  casServiceSkuInput: ".cas-service-sku-input",
  casAccountNoHidden: ".cas-account-no-hidden",
  casAccountTypeHidden: ".cas-account-type-hidden",
  casServiceSkuHidden: ".cas-service-sku-hidden",
  casServiceSkuRow: ".cas-service-sku-row",
  fxoReceiptTypeField: "#fxo-receipt-type-field",
  receiptTypeConsolidatedMsg:".receipt-type-consolidated-msg",
  casRequiredMandatoryFields: ".cas-required-mandatory-fields",
  containerIfNoCas: ".if-no-cas-number-container",
  containerIfCas: ".if-cas-number-container",  
  duplicateCasRow: "#cas-account-exist-error",
  fxoConfigCasRemoveButton: ".remove-acct",
  fxoCasAccountExist: ".fxo-cas-account-exist",
};

export default function FxoConfigurationWizardLogic(mainEl) {
  const self = this;
  const elsPage = {};
  const elsModals = {};
  var casAccountCount = 0;

  self.init = function() {
    setElements();
    bindElements();
    hideInitial();
  };

  function hideInitial(){
  }

  function setElements() {
    setElementsFromScope(elsPage, elementsPageMap, mainEl);
  }

  function bindElements() {
    elsPage.fxoConfigCasAddButton.on("click", addCasAccountRowFunc);
    elsPage.casAccountTypeInput.on("change", hideCasServiceSkuFunc);
  }

  $(document).on('click','.remove-acct', function() {        
    var singleSkuWrapper = $(this).closest(".fxo-cas-account-wrapper");
    singleSkuWrapper.remove();

    let recordExists = mainEl.find('.fxo-cas-account-exist');
    if(recordExists.length == 0){
      elsPage.noCasAccountEditContainer.show();
    }
  });

  
  var hideCasServiceSkuFunc = function() {
      elsPage.receiptTypeConsolidatedMsg.hide();
      if(this.value == 'Retailer Packaging') {
          // Not able to select 'Retailer Packaging when Receipt type is Consolidated'
          if($("#fxo-receipt-type-field").val() != 'single_ship') {
              elsPage.receiptTypeConsolidatedMsg.show();
              elsPage.casAccountTypeInput.val('');
              return false;
          } else {
            // hide CAS Service Sku
            elsPage.casServiceSkuInput.val('');
            elsPage.casServiceSkuRow.hide();
          }
      } else {
          elsPage.casServiceSkuRow.show();
          elsPage.receiptTypeConsolidatedMsg.hide();
      }
  }
  var casNumber = "";
  $(document).on('click','.fxo-config-cas-edit-button', function() {
    var id = this.id;
    var div_id = "#"+id.split("_")[1];
    var txt_id = "#txt_"+ id.split("_")[1];
    $(txt_id).css('display', 'block');
    casNumber = $(div_id).contents().get(2).nodeValue;
    $(div_id).contents().get(2).nodeValue = " ";
  });
 
  $(document).on('change keydown keypress','.fxo-config-cas-edit-text', function(e) {
    var enterPressed = false;
    var tabOut = false;
    if(e.type === 'keypress'){
      let keycode = (e.keyCode ? e.keyCode : e.which);
      if (keycode == '13') {
        enterPressed = true;
      }
    }
    if(e.type === 'keydown'){
      let keycode = (e.keyCode ? e.keyCode : e.which);
      if (keycode == '9') {
        tabOut = true;
      }
    }
    if(e.type === 'change'|| enterPressed || tabOut) {
      var txt_id = this.id;
      var value = $("#"+txt_id).val();
      var div_id = "#"+txt_id.split("_")[1];
      var retailerId = document.getElementById('fxo-cas-account-retailer-id').value;
      var ID = txt_id.split("_")[1];
      var ccaCasAccountNumber = casNumber;
      var editedCasAccountNo = value;
      var duplicate = false;
      if(editedCasAccountNo.length < 10 || editedCasAccountNo.length > 25 || (!$.isNumeric(editedCasAccountNo))){ 
        $("#lbl_"+ID).text("Please enter only numbers between 10 and 25 digits"); 
        $("#lbl_"+ID).css('display','inline-block');
        return false;       
      } else if(ccaCasAccountNumber == editedCasAccountNo){ 
        $("#lbl_"+ID).text("CAS Account Already Exists");
        $("#lbl_"+ID).css('display','inline-block');
        duplicate = true;
        return false;
      } else {
        $("#cas-account-exist-error").css('display','none'); 
        $("#lbl_"+ID).css('display','none');
        var casurl = $("#ca-account-fields").data("duplicate-url");
        $.ajax({
            url: casurl,
            type: 'GET',
            dataType: 'json',
            data: {"casAccount":editedCasAccountNo,"retailerId":retailerId},
            success: function(resp){
               if(resp && resp.status == 'Success') {           
                    $("#lbl_"+ID).text("CAS Account Already Exists");
                    $("#lbl_"+ID).css('display','inline-block');
                    duplicate = true;
                    return false;
                }
                /*else
                {
                  $(div_id).contents().get(2).nodeValue = value;
                  $("#"+txt_id).css('display', 'none');
                  var casurl = $("#"+txt_id).data("url");
                  $.ajax({
                      url: casurl,
                      type: 'GET',
                      dataType: 'json',
                      data: {"retailerId":retailerId,"ID":ID,"ccaCasAccountNumber":ccaCasAccountNumber,"editedCasAccountNo":editedCasAccountNo},
                      success: function(resp){
                        if(resp && resp.status == 'Success') {
                            $("#lbl_"+ID).css('display','none');
                              return true;
                            }    
                      },    
                      error: function(xhr,status,error) {
                        $("#cas-server-error").html("There appears to be an error that has occurred. Please contact your customer service representative.");
                        $("#cas-server-error").show();
                        return false;
                      }
                  });
                } */   
            },    
            error: function(xhr,status,error) {
              $("#cas-account-exist-error").css('display','none');        
              return false;
            }
        });
      }
      
    }
      
  });
  
  var casAccountArray = [];
  var addCasAccountRowFunc = function() {
    elsPage.casRequiredMandatoryFields.hide();
    /* var casServiceSkuInputFlag = true;
    if(elsPage.casAccountTypeInput.val() != 'Retailer Packaging'  && elsPage.casServiceSkuInput.val() == '') {
      casServiceSkuInputFlag = false;
    } */
    if(elsPage.casAccountNumberInput.val() != '' && elsPage.casAccountTypeInput.val() != ''
  /* && casServiceSkuInputFlag */) {
      var formObjName = "cmrCasAccounts";
      const fxoCasAccountEl = $(fxoCasAccountTemplate);
      let accountNo = fxoCasAccountEl.find(elementsPageMap.casAccountNo);
      //accountNo.text(elsPage.casAccountNumberInput.val());
      let accountType = fxoCasAccountEl.find(elementsPageMap.casAccountType);
      accountType.text($(".cas-account-type-input option:selected").val());
      let serviceSku = fxoCasAccountEl.find(elementsPageMap.casServiceSku);
      serviceSku.text($(".cas-service-sku-input option:selected").val());

      // set hidden attributesF
      let casAccountNoHiddenVar = fxoCasAccountEl.find(elementsPageMap.casAccountNoHidden);
      casAccountNoHiddenVar.val(elsPage.casAccountNumberInput.val());
      casAccountNoHiddenVar.attr('name', formObjName + "[" + casAccountCount + "].ccaCasAccountnNumber");
      let casAccountTypeHiddenVar = fxoCasAccountEl.find(elementsPageMap.casAccountTypeHidden);
      casAccountTypeHiddenVar.val(elsPage.casAccountTypeInput.val());
      casAccountTypeHiddenVar.attr('name', formObjName + "[" + casAccountCount + "].ccaCasAccountnType");
      let casServiceSkuHiddenVar = fxoCasAccountEl.find(elementsPageMap.casServiceSkuHidden);
      casServiceSkuHiddenVar.val(elsPage.casServiceSkuInput.val());
      casServiceSkuHiddenVar.attr('name', formObjName + "[" + casAccountCount + "].ccaCasServiceSku");

      hasDuplicates(elsPage.casAccountNumberInput.val());
        
      if(hasDupCasAccount === true){          
        elsPage.duplicateCasRow.show();       
      }else {
        elsPage.duplicateCasRow.hide();
        casAccountArray.push(elsPage.casAccountNumberInput.val());
        elsPage.casAccountEditContainer.append(fxoCasAccountEl);
        casAccountCount = casAccountCount + 1;
        elsPage.noCasAccountEditContainer.hide();
        elsPage.noCasAccountEditContainers.hide();
        elsPage.casAccountEditContainer.show();
        //emptyCasAccountDetail();
        elsPage.containerIfCas.show();
        elsPage.containerIfNoCas.hide();
    }
    } else {
      elsPage.casRequiredMandatoryFields.show();
    }
  }
  
  var hasDupCasAccount = false;
  function hasDuplicates(accountnumber){
    for(var index=0; index<casAccountArray.length; index++ ){
      if(accountnumber === casAccountArray[index] ){
        hasDupCasAccount = true; 
        return hasDupCasAccount;          
      }else{
        hasDupCasAccount = false;
      }      
    }
  }

  function emptyCasAccountDetail() {
      elsPage.casAccountNumberInput.val('');
      elsPage.casAccountTypeInput.val(null).trigger('change');
      elsPage.casServiceSkuInput.val(null).trigger('change');
  }

  function removeCasAccountRow() {
      var singleCasRowWrapper = $(this).closest(".fxo-cas-account-wrapper");
      singleCasRowWrapper.remove();
  }
}



// WEBPACK FOOTER //
// ./src/pages/fxoConfigurationForm/fxoConfigurationWizardLogic.js